export enum Launch_Vivo {
  pt = "pt",
  es = "es",
  hu = "hu",
}
